import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconTradingMoney = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round">
            <StyledPath
                d="M2 3.5C2.82843 3.5 3.5 2.82843 3.5 2C3.5 1.17157 2.82843 0.5 2 0.5C1.17157 0.5 0.5 1.17157 0.5 2C0.5 2.82843 1.17157 3.5 2 3.5Z"
                color="none"
            />
            <StyledPath d="M3.21472 2.88062L4.50006 3.81262" color="none" />
            <StyledPath
                d="M2 15.5C2.82843 15.5 3.5 14.8284 3.5 14C3.5 13.1716 2.82843 12.5 2 12.5C1.17157 12.5 0.5 13.1716 0.5 14C0.5 14.8284 1.17157 15.5 2 15.5Z"
                color="none"
            />
            <StyledPath d="M3.21472 13.1194L4.50006 12.1868" color="none" />
            <StyledPath
                d="M14 3.5C14.8284 3.5 15.5 2.82843 15.5 2C15.5 1.17157 14.8284 0.5 14 0.5C13.1716 0.5 12.5 1.17157 12.5 2C12.5 2.82843 13.1716 3.5 14 3.5Z"
                color="none"
            />
            <StyledPath d="M12.7853 2.88062L11.5 3.81262" color="none" />
            <StyledPath
                d="M14 15.5C14.8284 15.5 15.5 14.8284 15.5 14C15.5 13.1716 14.8284 12.5 14 12.5C13.1716 12.5 12.5 13.1716 12.5 14C12.5 14.8284 13.1716 15.5 14 15.5Z"
                color="none"
            />
            <StyledPath d="M12.7853 13.1194L11.5 12.1868" color="none" />
            <StyledPath
                d="M6.5 9.5C6.5 9.79667 6.58797 10.0867 6.7528 10.3334C6.91762 10.58 7.15189 10.7723 7.42598 10.8858C7.70006 10.9994 8.00166 11.0291 8.29264 10.9712C8.58361 10.9133 8.85088 10.7704 9.06066 10.5607C9.27044 10.3509 9.4133 10.0836 9.47118 9.79264C9.52906 9.50166 9.49935 9.20007 9.38582 8.92598C9.27229 8.65189 9.08003 8.41762 8.83336 8.2528C8.58668 8.08797 8.29667 8 8 8C7.70333 8 7.41332 7.91203 7.16665 7.74721C6.91997 7.58238 6.72771 7.34811 6.61418 7.07403C6.50065 6.79994 6.47094 6.49834 6.52882 6.20737C6.5867 5.91639 6.72956 5.64912 6.93934 5.43934C7.14912 5.22956 7.41639 5.0867 7.70737 5.02882C7.99834 4.97094 8.29994 5.00065 8.57403 5.11418C8.84811 5.22771 9.08238 5.41997 9.2472 5.66665C9.41203 5.91332 9.5 6.20333 9.5 6.5"
                color="none"
            />
            <StyledPath d="M8 4V5" color="none" />
            <StyledPath d="M8 11V12" color="none" />
        </StyledStrokedGroup>
    </StyledSvg>
);
